<div class="flex flex-column mb-1 w-100" style="max-width: 100%;">
  <ng-container *ngIf="files$ | async; let files" >
    <!-- Archivos que ya existen bien en la DB   -->
    <lib-file-item  *ngFor="let fileItem of files; index as i"
      [file]="fileItem"
      [canEdit]="canEdit"
      [canDelete]="canDelete"
      [canView]="canView"
      (action)="onAction($event, i, fileItem)">
    </lib-file-item>
  </ng-container>

  <!-- Archivos que están cargando -->
  <ng-container *ngFor="let uploadFile of uploadFiles; index as i">
    <lib-file-upload
      [file2Upload]="uploadFile"
      [collection] = "collection"
      [path]="path"
      [ref]="ref"
      (state)="onUploadFileState($event, uploadFile)"
    ></lib-file-upload>
  </ng-container>
</div>
